import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, DatePicker, Radio, Spin } from 'antd';

import moment from 'moment';
import 'moment/locale/pt-br';
import locale from 'antd/es/date-picker/locale/pt_BR';

import styled from 'styled-components';

import * as LegacyUserActions from 'vn-legacy-user/ducks/User';
import { addNewGuest } from './ducks/GuestsDucks';
import { sendInvites } from './ducks/InvitesDucks';
import FormGuestData from './components/FormGuestData';
import { cancel, resize, showError } from './ducks/ApplicationDucks';
import DocumentsList from './components/DocumentsList';
import DocumentTypesList from './components/DocumentTypesList';
import { useCallback } from 'react';

const sortBy = require('sort-by');

const App = ({ initialData }) => {

  const dispatch = useDispatch();
  const [isCaptureAllowed, setIsCaptureAllowed] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showingDatePicker, setShowingDatePicker] = useState(false);
  const [shareMode, setShareMode] = useState("acceptance");

  const application = useSelector(({ application }) => application);
  const inviteData = useSelector(({ invites }) => invites);
  const documents = useSelector(({ documents }) => documents);
  const documentTypes = useSelector(({ documentTypes }) => documentTypes);
  const initForWorkflowInstanceId = useSelector(state => state.application.workflowInstanceId);
  const guests = useSelector(({ guests }) => guests);

  const callInjectSessions = useCallback(
    sessions => dispatch(LegacyUserActions.injectSessions(sessions)),
    [dispatch, initialData]
  )

  const savingInvites = inviteData && inviteData.loading.save;

  const callAddNewGuest = useCallback(
    guest => dispatch(addNewGuest(guest)),
    [dispatch, guests]
  );

  const callCancel = useCallback(
    () => dispatch(cancel()),
    [dispatch]
  );

  const callSendInvites = useCallback(
    invites => dispatch(sendInvites(invites)),
    [dispatch, inviteData]
  );

  const callShowError = useCallback(
    error => dispatch(showError(error))
  );

  const callResize = useCallback(
    () => dispatch(resize())
  )

  useEffect(() => {
    if (initialData && !isInitialized) {
      callInjectSessions(initialData);
      setIsInitialized(true);
    }
  }, [callInjectSessions, initialData, isInitialized]);


  const cancelModal = () => {
    callCancel()
  }

  const handleSend = () => {

    const invitingGuests =
      Object.keys(guests)
        .map(guestIndex => guests[guestIndex]);

    const invitingGuestsHasError =
      invitingGuests.some(guestObject =>
        !guestObject.guest || guestObject.errors.name || (guestObject.errors.mobile && guestObject.errors.mail)
      );

    const invites =
      invitingGuests
        .map(guestObject => guestObject.guest)
        .filter(guest => guest)
        .map(guest => ({
          ...application,
          digitalSignData: {
            documentIds:
              documents.data && documents.data.length
                ? documents.data
                  .filter(documentObj => documentObj.selected && documentObj.hasSignature)
                  .map(documentObj => documentObj.idDocument)
                : application.hasSignature
                  ? application.documentIds
                  : []
          },
          documentIds:
            documents.data && documents.data.length
              ? documents.data
                .filter(documentObj => documentObj.selected)
                .map(documentObj => documentObj.idDocument)
              : !application.hasSignature
                ? application.documentIds
                : [],
          documentTypeIds:
            documentTypes.data && isCaptureAllowed
              ? documentTypes.data
                .filter(documentType => documentType.selected)
                .map(documentType => documentType.id)
              : [],
          guest: {
            name: guest.getName(),
            email: guest.getMail(),
            mobile: guest.getMobile(),
          },
          viewOnly: shareMode === 'share',
          expires: selectedDate && moment(selectedDate).format('DD/MM/YYYY')
        }));

    if (!invites.length) {
      callShowError('Você precisa preencher corretamente os dados dos convidados.');
      return;
    }

    const standardInvite = invites[0];

    const { documentIds, documentTypeIds, digitalSignData, guest } = standardInvite;

    const selectedDocumentTypeIds = Boolean(documentTypeIds && documentTypeIds.length)
    const selectedDocumentIds = Boolean(documentIds && documentIds.length)
    const selectedDigitalSign = Boolean(digitalSignData.documentIds && digitalSignData.documentIds.length);
    const contacts = Boolean(guest.email && guest.mobile)

    if (selectedDigitalSign && !contacts) {
      callShowError('Documentos para assinatura digital é necessário preencher os email e celular');
      return;
    }

    if (!selectedDocumentTypeIds && (!selectedDocumentIds && !selectedDigitalSign)) {
      callShowError('Você precisa selecionar pelo menos um documento para colaboração');
      return;
    }

    if (isCaptureAllowed && !selectedDocumentTypeIds) {
      callShowError('Você precisa selecionar pelo menos um documento para capturar!');
      return;
    }

    if (invitingGuestsHasError) {
      callShowError('Você precisa preencher corretamente os dados dos convidados');
      return;
    }

    callSendInvites(invites);
  }

  const resizeModal = () => {
    callResize();
  }

  useEffect(() => {
    resizeModal();
  }, [isCaptureAllowed])

  return (
    <Fragment>
      <h1>Convidar para colaborar</h1>
      <CloseButtonArea>
        <CloseButton
          icon="close"
          onClick={cancelModal}
          shape="circle"
          type="link" />
      </CloseButtonArea>
      {
        Object.keys(guests)
          .map(guestIndex => parseInt(guestIndex, 10))
          .map(guestIndex =>
            <FormGuestData
              addNewGuest={callAddNewGuest}
              index={guestIndex}
              isTheFirstForm={guestIndex === 0}
              isTheLatestForm={guestIndex === Object.keys(guests).length - 1}
              key={guestIndex} />
          )
      }
      {
        initForWorkflowInstanceId &&
        documents &&
        documents.data &&
        (
          <Fragment>
            <Spin spinning={documents.loading.fetch}>
              {
                documents.data
                  .find(document => document.hasSignature) &&
                <div style={{ paddingBottom: 20 }}>
                  <h2>Documentos para assinatura digital</h2>
                  <DocumentsList
                    documents={
                      documents.data
                        .filter(document => document.hasSignature)
                        .sort(sortBy('idDocument'))
                    }
                    loading={documents.loading.fetch} />
                </div>
              }
              <h2>Documentos para aceite externo e compartilhamento</h2>
              <ShareModeContainer>
                <Radio.Group
                  onChange={evt => {
                    setShowingDatePicker(evt.target.value === 'share');
                    setShareMode(evt.target.value)
                  }}
                  value={shareMode}>
                  <CollumnRadio value="acceptance">
                    Aceite externo
                  </CollumnRadio>
                  <CollumnRadio value="share">
                    Compartilhar
                    {
                      showingDatePicker &&
                      <DatePickerSpan>
                        até
                        <DatePickerContainer>
                          <DatePicker
                            disabledDate={current => current && current < moment().endOf('day')}
                            locale={locale}
                            format={'DD/MM/YYYY'}
                            onChange={setSelectedDate} />
                        </DatePickerContainer>
                      </DatePickerSpan>
                    }
                  </CollumnRadio>
                </Radio.Group>
              </ShareModeContainer>
              <DocumentsList
                documents={
                  documents.data
                    .filter(document => document.hasCollaboration && !document.hasSignature)
                    .sort(sortBy('idDocument'))
                }
                loading={documents.loading.fetch} />
            </Spin>
          </Fragment>
        )

      }
      {
        !initForWorkflowInstanceId &&
        (application.hasSignature ? (
          <Radio value="signature" checked>
            Assinatura digital
          </Radio>
        ) : (<ShareModeContainer>
          <Radio.Group
            onChange={evt => {
              setShowingDatePicker(evt.target.value === 'share');
              setShareMode(evt.target.value)
            }}
            value={shareMode}>
            <CollumnRadio value="acceptance">
              Aceite externo
            </CollumnRadio>
            <CollumnRadio value="share">
              Compartilhar
              {
                showingDatePicker &&
                <DatePickerSpan>
                  até
                  <DatePickerContainer>
                    <DatePicker
                      disabledDate={current => current && current < moment().endOf('day')}
                      locale={locale}
                      format={'DD/MM/YYYY'}
                      onChange={setSelectedDate} />
                  </DatePickerContainer>
                </DatePickerSpan>
              }
            </CollumnRadio>
          </Radio.Group>
        </ShareModeContainer>)
        )
      }

      {
        documentTypes &&
        documentTypes.data &&
        <div style={{ marginTop: '30px' }}>
          <Spin spinning={documentTypes.loading.fetch}>
            <h2>
              <Checkbox
                checked={isCaptureAllowed}
                onChange={() => setIsCaptureAllowed(!isCaptureAllowed)}>
                Capturar documentos
                </Checkbox>
            </h2>
            {
              isCaptureAllowed &&
              <DocumentTypesList
                documentTypes={
                  documentTypes.data
                    .sort(sortBy('name'))
                }
                loading={documentTypes.loading.fetch} />
            }
          </Spin>
        </div>
      }
      <ActionsContainer>
        <Button
          type="dashed"
          onClick={cancelModal}>
          Cancelar
        </Button>
        <Button
          loading={savingInvites}
          icon="usergroup-add"
          onClick={handleSend}>
          Enviar
        </Button>
      </ActionsContainer>
    </Fragment>
  );
};

const ActionsContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;

  & > Button {
    margin: 0 5px;
  }
`;

const CloseButtonArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 20px;
`;

const CloseButton = styled(Button)`
  border: none;
  font-size: 12px;
  height: 30px;
  width: 30px;
`;

const CollumnRadio = styled(Radio)`
  display: block;
  line-height: 34px;
`;

const ShareModeContainer = styled.div`
  margin: 10px 0;
`;

const DatePickerSpan = styled.span`
  display: inline-block;
  margin-left: 3px;
`;

const DatePickerContainer = styled.div`
  display: inline-block;
  margin-left: 10px;
`;

export default App;



// WEBPACK FOOTER //
// ./src/App.js